import { useState, useCallback } from "react";

const useCreateComment = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const createComment = useCallback(async (blogId, commentData) => {
    if (!blogId) {
      setError(new Error("Blog ID is required"));
      return null;
    }

    setIsLoading(true);
    setIsSuccess(false);
    setIsError(false);
    setError(null);

    try {
      const baseUrl = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${baseUrl}/blogs/${blogId}/comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(commentData),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = data?.message || "Failed to create comment";
        throw new Error(message);
      }

      setIsSuccess(true);
      return data;
    } catch (err) {
      setIsError(true);
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { createComment, isLoading, isSuccess, isError, error };
};

export default useCreateComment;

